import { logUsage } from 'owa-analytics';
import { DatapointVariant } from 'owa-analytics-types';
import type { CalendarPayload } from '../schema';

interface CanvasLoadCalendarAssetsData {
    dayView: number;
    agendaView: number;
    workWeekView: number;
    weekView: number;
    monthView: number;
}

interface CalendarLoadDayViewData {
    oneDayView: number;
    twoThreeDaysView: number;
    fourFiveDaysView: number;
    sixSevenDaysView: number;
}

export function logCalendarAssetPayload(assets) {
    let canvasAssetPayload: CanvasLoadCalendarAssetsData = {
        dayView: 0,
        agendaView: 0,
        workWeekView: 0,
        weekView: 0,
        monthView: 0,
    };
    let numDaysAssetPayload: CalendarLoadDayViewData = {
        oneDayView: 0,
        twoThreeDaysView: 0,
        fourFiveDaysView: 0,
        sixSevenDaysView: 0,
    };

    assets.forEach(asset => {
        const calPayload: CalendarPayload = asset.payload ?? {};
        if (calPayload.viewType == 'day' && calPayload.numDaysInDayView) {
            canvasAssetPayload.dayView += 1;
            calPayload.numDaysInDayView >= 6
                ? (numDaysAssetPayload.sixSevenDaysView += 1)
                : calPayload.numDaysInDayView >= 4
                ? (numDaysAssetPayload.fourFiveDaysView += 1)
                : calPayload.numDaysInDayView >= 2
                ? (numDaysAssetPayload.twoThreeDaysView += 1)
                : (numDaysAssetPayload.oneDayView += 1);
        } else if (calPayload.viewType == 'agenda') {
            canvasAssetPayload.agendaView += 1;
        } else if (calPayload.viewType == 'workweek') {
            canvasAssetPayload.workWeekView += 1;
        } else if (calPayload.viewType == 'week') {
            canvasAssetPayload.weekView += 1;
        } else if (calPayload.viewType == 'month') {
            canvasAssetPayload.monthView += 1;
        }
    });
    logUsage(
        'canvasLoadCalendarAssets',
        {
            ...canvasAssetPayload,
        },
        { variant: DatapointVariant.WarmOnly }
    );
    logUsage(
        'canvasLoadDayViewAssets',
        {
            ...numDaysAssetPayload,
        },
        { variant: DatapointVariant.WarmOnly }
    );
}
